import React from 'react';
import Badge from '../DataTableFields/Badge';

const SoftwareBadge = ({ value }) => {
  if (value?._id) {
    return <div>{value?.name}</div>;
  }

  return <div>-</div>;
};

export default SoftwareBadge;
